import { gql } from '@apollo/client';

export default gql`
  mutation cancelHotelBooking($options: CancelHotelBookingInput!) {
    cancelHotelBooking(options: $options) {
      bookingCode
      pnr
      rooms {
        code
        from
        to
      }
      hotel {
        id
        name
      }
    }
  }
`;
